/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ppi_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work out a display's pixel density (PPI) from its resolution and diagonal size. Enter the width, height and screen size to get PPI and the dot pitch.`)
};

const es_ppi_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula la densidad de píxeles (PPI) de una pantalla a partir de su resolución y tamaño diagonal. Introduce el ancho, el alto y el tamaño de pantalla para obtener el PPI y el paso de píxel.`)
};

const de_ppi_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ermittle die Pixeldichte (PPI) eines Displays aus Auflösung und Bilddiagonale. Gib Breite, Höhe und Bildschirmgröße ein, um PPI und Pixelabstand zu erhalten.`)
};

const nl_ppi_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken de pixeldichtheid (PPI) van een scherm op basis van resolutie en diagonale grootte. Vul breedte, hoogte en schermgrootte in om de PPI en dot pitch te krijgen.`)
};

const fr_ppi_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculez la densité de pixels (PPP) d'un écran à partir de sa résolution et de sa taille diagonale. Saisissez la largeur, la hauteur et la taille d'écran pour obtenir le PPP et le pas de masque.`)
};

const it_ppi_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola la densità di pixel (PPI) di un display dalla risoluzione e dalla dimensione diagonale. Inserisci larghezza, altezza e dimensione dello schermo per ottenere il PPI e il dot pitch.`)
};

const pt_br2_ppi_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule a densidade de pixels (PPI) de uma tela a partir da resolução e do tamanho diagonal. Informe a largura, a altura e o tamanho da tela para obter o PPI e o dot pitch.`)
};

const pt_ppi_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule a densidade de pixels (PPI) de um ecrã a partir da sua resolução e tamanho diagonal. Introduza a largura, a altura e o tamanho do ecrã para obter o PPI e o pitch de píxel.`)
};

const ja_ppi_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解像度と対角サイズからディスプレイのピクセル密度(PPI)を算出します。幅、高さ、画面サイズを入力するとPPIとドットピッチが得られます。`)
};

const zh_ppi_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据分辨率和对角线尺寸计算显示屏的像素密度（PPI）。输入宽度、高度和屏幕尺寸即可得到 PPI 和点距。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ppi_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ppi_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ppi_intro", locale)
	if (locale === "en") return en_ppi_intro(inputs)
	if (locale === "es") return es_ppi_intro(inputs)
	if (locale === "de") return de_ppi_intro(inputs)
	if (locale === "nl") return nl_ppi_intro(inputs)
	if (locale === "fr") return fr_ppi_intro(inputs)
	if (locale === "it") return it_ppi_intro(inputs)
	if (locale === "pt-BR") return pt_br2_ppi_intro(inputs)
	if (locale === "pt") return pt_ppi_intro(inputs)
	if (locale === "ja") return ja_ppi_intro(inputs)
	return zh_ppi_intro(inputs)
};